import { makeRequest } from '@/libs/RequestModule'

const getQrcodePix = async function (totalValue, isInvoiceMode, idBoletos, rechargeValues) {
    const response = (await makeRequest('getQrcodePix', { totalValue, isInvoiceMode, idBoletos, rechargeValues }))?.data
    return response
}

const checkPixInvoicePayment = async function (idBoletos, nit, pixTimeout, totalValue) {
    const response = (await makeRequest('checkPixInvoicePayment', { idBoletos, nit, pixTimeout, totalValue }))?.data
    return response
}

export { getQrcodePix, checkPixInvoicePayment }
